import React, { Component, useState } from "react";
import { useContext } from "react";
import { BsFillHeartFill } from "react-icons/bs";
import Slider from "react-slick";
import axios from "axios";
import { Helmet } from "react-helmet";
import $ from "jquery";

import {
  Row,
  Col,
  Accordion,
  Table,
  Carousel,
  Badge,
  Nav,
  Button,
} from "react-bootstrap";
import { Link } from "react-router-dom";

import CartContext from "./CartContext";
import { Footer, Testimonial, Vendors } from "./Home";

export class CareersPage extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  render() {
    return (
      <>
        {/* <Helmet>
          <script src="/lib/wow/wow.min.js"></script>
          <script src="/lib/easing/easing.min.js"></script>
          <script src="/lib/waypoints/waypoints.min.js"></script>
          <script src="/lib/counterup/counterup.min.js"></script>
          <script src="/lib/owlcarousel/owl.carousel.min.js"></script>
          <script src="/js/main.js"></script>
        </Helmet> */}
        <div
          class="container-fluid bg-primary py-5 bg-header"
          style={{ marginBottom: "90px;" }}
        >
          <div class="row py-5">
            <div class="col-12 pt-lg-5 mt-lg-5 text-center">
              <h1 class="display-4 text-white animated zoomIn">Careers </h1>
              <a href="" class="h5 text-white">
                Home
              </a>
              <i class="far fa-circle text-white px-2"></i>
              <a href="" class="h5 text-white">
                About
              </a>
            </div>
          </div>
        </div>
        <Careers></Careers>
        {/* <Testimonial></Testimonial>
        <Vendors></Vendors> */}
        <Footer></Footer>
      </>
    );
  }
}

export class Careers extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  render() {
    return (
      <>
        <Helmet>
          <script src="/lib/wow/wow.min.js"></script>
          <script src="/lib/easing/easing.min.js"></script>
          <script src="/lib/waypoints/waypoints.min.js"></script>
          <script src="/lib/counterup/counterup.min.js"></script>
          <script src="/lib/owlcarousel/owl.carousel.min.js"></script>
          <script src="/js/main.js"></script>
        </Helmet>

        {/* <!-- About Start --> */}
        <div class="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s">
          <div class="container py-5">
            <div class="row g-5">
              <div class="col-lg-7">
                <div class="section-title position-relative pb-3 mb-5">
                  <h5 class="fw-bold text-primary text-uppercase">Careers</h5>
                  <h1 class="mb-0">
                    We are Best-in-class and cutting-edge IT Solution Company.
                  </h1>
                </div>
                <p class="mb-4">
                  Join our Team and embark on a successful journey of your
                  career. We offer dynamic opportunities to shape the future.
                  Whether you're an experienced professional or just starting,
                  explore your potential with us and be a part of our mission to
                  revolutionize IT solutions. Grow with a company dedicated to
                  your success.
                </p>
                <div class="row g-0 mb-3">
                  <div class="col-sm-6 wow zoomIn" data-wow-delay="0.2s">
                    <h5 class="mb-3">
                      <i class="fa fa-check text-primary me-3"></i>Great working
                      Culture
                    </h5>
                    <h5 class="mb-3">
                      <i class="fa fa-check text-primary me-3"></i>Professional
                      Environment
                    </h5>
                  </div>
                  <div class="col-sm-6 wow zoomIn" data-wow-delay="0.4s">
                    <h5 class="mb-3">
                      <i class="fa fa-check text-primary me-3"></i>Cutting-Edge
                      Technology
                    </h5>
                    <h5 class="mb-3">
                      <i class="fa fa-check text-primary me-3"></i>Competitive
                      Salary
                    </h5>
                  </div>
                </div>
                <div
                  class="d-flex align-items-center mb-4 wow fadeIn"
                  data-wow-delay="0.6s"
                >
                  <div
                    class="bg-primary d-flex align-items-center justify-content-center rounded"
                    style={{ width: "60px;", height: "60px;" }}
                  >
                    <i class="fa fa-phone-alt text-white"></i>
                  </div>
                  <div class="ps-4">
                    <h5 class="mb-2">Email your CV to </h5>
                    <h4 class="text-primary mb-0">support@elasticcart.com</h4>
                  </div>
                </div>
              </div>
              <div class="col-lg-5" style={{ minHeight: "500px;" }}>
                <div class="position-relative h-100">
                  <img
                    class="position-absolute w-100 h-100 rounded wow zoomIn"
                    data-wow-delay="0.9s"
                    src="img/about.jpg"
                    style={{ objectFit: "cover;" }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
